import { useParams } from 'react-router-dom';
import { AddToShoppingListModal } from '@/features/shopping-list/components/AddToShoppingListModal';
import { useGetFromRecipeQuery } from '@/features/shopping-list/api';

export function AddToShoppingListPage() {  
  const { householdId, id: recipeId } = useParams();
  const apiResult = useGetFromRecipeQuery({ householdId, recipeId });  
  
  return (    
    <AddToShoppingListModal source="recipe" {...apiResult} />
  );
}
